import script from "./UdcSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./UdcSelect.vue?vue&type=script&setup=true&lang=ts"

import "./UdcSelect.vue?vue&type=style&index=0&id=7b75e42a&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b75e42a"]])

export default __exports__